var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomelight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1849_2981",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1849_2981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 19.5H9.34615V14.4615C9.34615 14.2055 9.43277 13.9908 9.606 13.8176C9.77923 13.6443 9.9939 13.5577 10.25 13.5577H13.75C14.0061 13.5577 14.2207 13.6443 14.3939 13.8176C14.5672 13.9908 14.6538 14.2055 14.6538 14.4615V19.5H18V10.6539C18 10.6026 17.9888 10.5561 17.9663 10.5144C17.9439 10.4728 17.9134 10.4359 17.875 10.4039L12.1827 6.12501C12.1314 6.08015 12.0705 6.05771 12 6.05771C11.9295 6.05771 11.8686 6.08015 11.8173 6.12501L6.12497 10.4039C6.08652 10.4359 6.05607 10.4728 6.03362 10.5144C6.01119 10.5561 5.99997 10.6026 5.99997 10.6539V19.5ZM4.5 19.5V10.6539C4.5 10.3676 4.56402 10.0965 4.69207 9.84041C4.82012 9.58433 4.99712 9.37344 5.22307 9.20774L10.9154 4.91929C11.2313 4.67826 11.5923 4.55774 11.9984 4.55774C12.4046 4.55774 12.7666 4.67826 13.0846 4.91929L18.7769 9.20774C19.0028 9.37344 19.1798 9.58433 19.3079 9.84041C19.4359 10.0965 19.5 10.3676 19.5 10.6539V19.5C19.5 19.909 19.3522 20.2612 19.0567 20.5567C18.7612 20.8522 18.4089 21 18 21H14.0577C13.8016 21 13.5869 20.9134 13.4137 20.7401C13.2404 20.5669 13.1538 20.3522 13.1538 20.0961V15.0577H10.8461V20.0961C10.8461 20.3522 10.7595 20.5669 10.5863 20.7401C10.413 20.9134 10.1984 21 9.94227 21H5.99997C5.59101 21 5.23877 20.8522 4.94327 20.5567C4.64776 20.2612 4.5 19.909 4.5 19.5Z",
    fill: "#CED4DA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelight);
export default __webpack_public_path__ + "static/media/home(light).a3f958672e1a4fecbcfeca5d1d16d341.svg";
export { ForwardRef as ReactComponent };